import { aboutContent } from '@/mocks/siteData';

export default function BrandIntro() {
  return (
    <section className="py-10 md:py-14">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-5">
            品牌故事
          </h2>
          <div className="flex flex-col gap-4">
            {aboutContent.brandStory.map((para, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                {para}
              </p>
            ))}
          </div>
        </div>
        <div className="relative h-72 md:h-96 rounded-lg overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20a%20cozy%20creative%20workspace%20with%20books%20and%20plants%2C%20soft%20amber%20and%20cream%20tones%2C%20gentle%20natural%20light%20streaming%20through%20window%2C%20editorial%20style%2C%20harmonious%20calm%20atmosphere%2C%20sophisticated%20minimalist%20composition&width=800&height=600&seq=about-brand&orientation=landscape"
            alt="姐姐的朋友 品牌故事"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}